import { EzBadParamException } from '/ezlibrary/exceptions/EzBadParamException.js';

import {
    EzNumber
} from '/ezlibrary/helpers/EzHelpers.js';

import { EzClass } from '/ezlibrary/EzClass.js';
import { EzUx } from '/ezlibrary/ux/EzUx.js';

/**
 * @class
 * @extends {EzClass}
 * @descrption
 * Performs javascript page layout operations
 * Import with:
 * import { EzLayoutHelper } from '/public/javascript/common/ezclocker-layout-helper.js';
 * @deprecated
 * Migrate to a different solution.
 * Will remove this class in a future release.
 */
export class EzLayoutHelper extends EzClass {
    /**
     * @public @method
     * @returns {EzLayoutHelper}
     */
    ezInit() {
        return EzLayoutHelper.ezInstance;
    }

    /**
     * @public @method
     * @param {string} id
     *
     * @deprecated
     * Migrate to: EzUx.$id(id)
     */
    ezItemRef(id) {
        return EzUx.$id(id);
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemHeightMargins(id) {
        const item = EzUx.$id(id);

        return item.outerHeight(true) - item.innerHeight();
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemWidthMargins(id) {
        const item = EzUx.$id(id);

        return item.outerWidth(true) - item.innerWidth();
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemWidth(id) {
        const item = EzUx.$id(id);

        return item.outerWidth(true);
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemHeight(id) {
        const item = EzUx.$id(id);

        return item.outerHeight(true);
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemContentSize(id) {
        const item = EzUx.$id(id);

        return {
            height: item.innerHeight(),
            width: item.innerWidth()
        };
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemPadding(id) {
        const item = EzUx.$id(id);

        return {
            height: EzNumber.strToInt(item.css('padding-top')) + EzNumber.strToInt(item.css('padding-bottom')),
            width: EzNumber.strToInt(item.css('padding-left')) + EzNumber.strToInt(item.css('passing-right')),
            top: EzNumber.strToInt(item.css('padding-top')),
            bottom: EzNumber.strToInt(item.css('padding-bottom')),
            left: EzNumber.strToInt(item.css('padding-left')),
            right: EzNumber.strToInt(item.css('passing-right'))
        };
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemMargins(id) {
        const item = EzUx.$id(id);

        return {
            height: EzNumber.strToInt(item.css('margin-top')) + EzNumber.strToInt(item.css('margin-bottom')),
            width: EzNumber.strToInt(item.css('margin-left')) + EzNumber.strToInt(item.css('margin-right')),
            top: EzNumber.strToInt(item.css('margin-top')),
            bottom: EzNumber.strToInt(item.css('margin-bottom')),
            left: EzNumber.strToInt(item.css('margin-left')),
            right: EzNumber.strToInt(item.css('margin-right'))
        };
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemDiminsions(id) {
        const item = EzUx.$id(id);

        let outerH = item.outerHeight(true);

        if (isNaN(outerH)) {
            outerH = 0;
        }
        let innerH = item.innerHeight();

        if (isNaN(innerH)) {
            innerH = 0;
        }

        let outerW = item.outerWidth(true);

        if (isNaN(outerW)) {
            outerW = 0;
        }

        let innerW = item.innerWidth();

        if (isNaN(innerW)) {
            innerW = 0;
        }

        const results = id === 'window'
            ? {
                id,
                outer: {
                    height: outerH,
                    width: outerW
                },
                inner: {
                    height: innerH,
                    width: innerW
                },
                rect: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0
                },
                marginH: (outerH - innerH),
                marginW: (outerW - innerW),
                margin: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                },
                paddingH: 0,
                paddingW: 0,
                padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                },
                borderH: 0,
                borderW: 0,
                border: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                }
            }
            : {
                id,
                outer: {
                    height: outerH,
                    width: outerW
                },
                inner: {
                    height: innerH,
                    width: innerW
                },
                rect: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0
                },
                marginH: (outerH - innerH),
                marginW: (outerW - innerW),
                margin: {
                    top: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'margin-top'),
                    bottom: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'margin-bottom'),
                    left: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'margin-left'),
                    right: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'margin-right')
                },
                paddingH: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'padding-top') +
                    EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'padding-bottom'),
                paddingW: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'padding-left') +
                    EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'passing-right'),
                padding: {
                    top: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'padding-top'),
                    bottom: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'padding-bottom'),
                    left: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'padding-left'),
                    right: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'passing-right')
                },
                borderH: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-top-width') +
                    EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-bottom-width'),
                borderW: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-left-width') +
                    EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-right-width'),
                border: {
                    top: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-top-width'),
                    bottom: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-bottom-width'),
                    left: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-left-width'),
                    right: EzLayoutHelper.ezInstance.ezGetCssValueAsIntOrZero(item, 'border-right-width')
                }
            };

        const offset = item.offset();

        if (offset) {
            results.rect.top = isNaN(offset.top)
                ? 0
                : offset.top;
            results.rect.left = isNaN(offset.left)
                ? 0
                : offset.top;
            results.rect.right = isNaN(offset.left)
                ? 0
                : offset.top + results.inner.width + results.margin.right;
            results.rect.bottom = isNaN(offset.top)
                ? 0
                : offset.top + results.inner.height + results.margin.bottom;
        }

        return results;
    }

    /**
     * @public @method
     * Returns the CSS value as a number or zero.
     * @returns {Number}
     */
    ezGetCssValueAsIntOrZero(element, cssPropName) {
        const result = EzNumber.strToInt(element.css(cssPropName));

        return isNaN(result)
            ? 0
            : result;
    }

    /**
     * @public @method
     * Returns the current window dimition
     * @returns {Object}
     * {
     *      height: {number},
     *      width: {number}
     * }
     */
    windowDiminisions() {
        const item = globalThis.ezApi.ezWindow();

        return {
            height: item.height(),
            width: item.width()
        };
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemCenter(id) {
        return EzNumber.strToInt(
            EzNumber.numberOrDefault(
                EzUx.$id(id)?.innerWidth(),
                2) / 2,
            10);
    }

    /**
     * @public @method
     * @param {string} id
     */
    itemMiddle(id) {
        const item = EzUx.$id(id);

        return EzNumber.strToInt(item.innerHeight() / 2);
    }

    /**
     * @public @method
     * @param {string} parentId
     * @param {string} contentId
     */
    sizeContentHeightWithinContainer(parentId, contentId) {
        if (!globalThis.ezApi.ezStringHasLength(parentId)) {
            throw new EzBadParamException(
                'parentId',
                EzLayoutHelper.ezInstance,
                EzLayoutHelper.ezInstance.sizeContentHeightWithinContainer);
        }
        if (!globalThis.ezApi.ezStringHasLength(contentId)) {
            throw new EzBadParamException(
                'contentId',
                EzLayoutHelper.ezInstance,
                EzLayoutHelper.ezInstance.sizeContentHeightWithinContainer);
        }

        const pDim = EzLayoutHelper.ezInstance.itemDiminsions(parentId);

        const cDim = EzLayoutHelper.ezInstance.itemDiminsions(contentId);

        const cDimPaddingHeight = isNaN(cDim.borderH)
            ? 0
            : cDim.paddingH;

        const cDimMarginHeight = isNaN(cDim.marginH)
            ? 0
            : cDim.marginH;

        const content = EzUx.$id(contentId);

        const newHeight = pDim.inner.height - ((cDim.rect.top - pDim.rect.top) + (cDimPaddingHeight + cDimMarginHeight));

        content.height(newHeight);
    }

    /**
     * @public @method
     * Size the content (contentId) to fit within the window diminisons taking into account height of header (headerId),
     * menu (menuId) items.
     *
     * @param {string} headerId
     * @param {string} menuId
     * @param {string} contentId
     */
    sizeContentBelowHeaderAndMenu(headerId, menuId, contentId) {
        if (!headerId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing header id reference.');
            return;
        }
        if (!menuId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing menu id reference.');
            return;

        }
        if (!contentId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing content id reference.');
            return;
        }

        const wDim = EzLayoutHelper.ezInstance.windowDiminisions();

        const hDim = EzLayoutHelper.ezInstance.itemDiminsions(headerId);

        const mDim = EzLayoutHelper.ezInstance.itemDiminsions(menuId);

        const cDim = EzLayoutHelper.ezInstance.itemDiminsions(contentId);

        const cDimBorderHeight = isNaN(cDim.borderH) ? 0 : cDim.borderH;

        const cDimMarginHeight = isNaN(cDim.marginH) ? 0 : cDim.marginH;

        const content = EzUx.$id(contentId);

        const newHeight = wDim.height - (hDim.outer.height + mDim.outer.height + cDimBorderHeight + cDimMarginHeight);

        content.height(newHeight - 8);
    }

    /**
     * @public @method
     * Size the content associated with contentId to fit within the window diminisons taking into account height of header (headerId),
     * menu (menuId), and sub-menu (subMenuId) items.)
     *
     * @param {string} headerId
     * @param {string} menuId
     * @param {string} subMenuId
     * @param {string} contentId
     */
    sizeContentBelowHeaderMenuAndSubMenu(headerId, menuId, subMenuId, contentId) {
        if (!headerId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing header id reference.');
            return;
        }
        if (!menuId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing menu id reference.');
            return;

        }
        if (!contentId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing content id reference.');
            return;
        }
        if (!subMenuId) {
            globalThis.ezApi.ezclocker.ezLogger.error('Missing subMenuId id reference.');
            return;
        }

        const wDim = EzLayoutHelper.ezInstance.windowDiminisions();

        const hDim = EzLayoutHelper.ezInstance.itemDiminsions(headerId);

        const mDim = EzLayoutHelper.ezInstance.itemDiminsions(menuId);

        const smDim = EzLayoutHelper.ezInstance.itemDiminsions(subMenuId);

        const cDim = EzLayoutHelper.ezInstance.itemDiminsions(contentId);

        const content = EzUx.$id(contentId);

        const newHeight = wDim.height - (hDim.outer.height + mDim.outer.height + +smDim.outer.height + cDim.borderH + cDim.marginH);

        content.height(newHeight);
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Class Initialization and EzApi Registration Section
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond this section !!
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    /**
     * @static
     * @public @readonly @property
     * Gets the name of this class's singleton instance when registered with globalThis.ezApi.
     *
     * @returns {string}
     */
    static get ezApiName() {
        return 'ezLayoutHelper';
    }

    /**
     * @static
     * @public @readonly @property
     * Gets an object of event names that this class may trigger.
     *
     * @returns {object}
     */
    static get ezEventNames() {
        return {
            onReady: 'ezOn_EzLayoutHelper_Ready',
            onEmployerDashboardControllerInitialized: 'ezOn_EmployerDashboardController_Initialized'
        };
    }

    /**
     * @static
     * @private @field
     * Stores the singleton instance of this class that was created by and registerd with globalThis.ezApi.
     *
     * @type {EzLayoutHelper}
     */
    static #ezInstance = globalThis?.ezApi?.ready && globalThis?.ezApi?.ezclocker?.[EzLayoutHelper.ezApiName]
        ? globalThis.ezApi.ezclocker[EzLayoutHelper.ezApiName]
        : null;
    /**
     * @static
     * @public @property @getter
     * Gets the singleton instance of this class that is registered with EzApi (if available yet)
     *
     * @returns {EzLayoutHelper}
     */
    static get ezInstance() {
        return EzLayoutHelper.#ezInstance;
    }
    /**
     * @static
     * @public @property @setter
     * Sets the singleton instance of of this class that is registered with globalThis.ezApi.
     *
     * @param {EzLayoutHelper} instance
     */
    static set ezInstance(instance) {
        if (null != EzLayoutHelper.#ezInstance) {
            throw new Error('EzLayoutHelper\'s singleton instance is already reigstered with globalThis.ezApi.');
        }

        EzLayoutHelper.#ezInstance = instance;
    }

    /**
     * @static
     * @private @field
     * Stores the EzApi registration state for this class.
     * Default value is NULL
     * Class is registerd with EzApi when value is EzRegistrationState.REGISTERED
     *
     * @type {string}
     * A valid enum property value from EzRegistrationState
     */
    static #ezApiRegistrationState = globalThis?.ezApi?.ready && globalThis.ezApi?.ezclocker?.[EzLayoutHelper.ezApiName]
        ? EzRegistrationState.REGISTERED
        : null;
    /**
     * @static
     * @public @property @getter
     * Gets the ezApi registration state of this classes's singleton instance.
     *
     * @returns {string}
     * A valid enum property value from EzRegistrationState
     */
    static get ezApiRegistrationState() {
        return EzLayoutHelper.#ezApiRegistrationState;
    }
    /**
     * @static
     * @public @property @setter
     * Sets the ezApi registration state of this classes's singleton instance.
     *
     * @param {string} ezApiRegistrationState
     * A valid enum property value from EzRegistrationState
     */
    static set ezApiRegistrationState(ezApiRegistrationState) {
        EzLayoutHelper.#ezApiRegistrationState = EzRegistrationState.ezValueOf(ezApiRegistrationState);
    }

    /**
     * @static
     * @private @readonly @property
     * Gets true when all required dependencies for this class report ready.
     * In otherwords, the require dependency's singleton instance is created
     * and is registered with and accessable from EzApi with globalThis.ezApi.ezclocker.{dependency_name}.
     *
     * @returns {boolean}
     */
    static get #ezCanRegister() {
        return EzRegistrationState.PENDING === EzLayoutHelper.ezApiRegistrationState &&
            globalThis?.ezApi?.ready && globalThis?.ezApi?.ezclocker;
    }

    /**
     * @static
     * @private @readonly @property
     * Gets if this class's singleton instance is registered with ezApi yet.
     *
     * @returns {boolean}
     */
    static get #ezIsRegistered() {
        return null != EzLayoutHelper.ezInstance &&
            EzRegistrationState.REGISTERED === EzLayoutHelper.ezApiRegistrationState;
    }

    /**
     * @static
     * @private @method
     * Attempts to register the singleton instance for this class with globalThis.ezApi. Returns true
     * if successful, false otherwise.
     *
     * @returns {boolean}
     */
    static #ezRegistrator() {
        if (EzLayoutHelper.#ezCanRegister && !EzLayoutHelper.#ezIsRegistered) {
            globalThis.ezApi.ezRegisterNewApi(EzLayoutHelper, EzLayoutHelper.ezApiName);
        }

        return EzLayoutHelper.#ezIsRegistered;
    }

    /**
     * @static
     * Static Initialization
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * >> IMPORTANT <<
     * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
     * Make sure the following properties and methods get defined BEFORE this static initialization section:
     *     1) Property getter EzLayoutHelper.ezApiName
     *     2) Property getter EzLayoutHelper.ezEventNames
     *     3) Property getter EzLayoutHelper.ezInstance
     *     4) Property setter EzLayoutHelper.ezInstance
     *     5) Property getter EzLayoutHelper.ezApiRegistrationState
     *     6) Property setter EzLayoutHelper.ezApiRegistrationState
     *     7) Property getter EzLayoutHelper.#ezCanRegister
     *     8) Property getter EzLayoutHelper.#ezIsRegistered
     *     9) Method EzLayoutHelper.#ezRegistrator()
     */
    static {
        if (!EzLayoutHelper.#ezIsRegistered) {
            EzLayoutHelper.ezApiRegistrationState = EzRegistrationState.PENDING;

            if (!EzLayoutHelper.#ezRegistrator()) {
                EzClass.ezWaitReady(
                    EzClass.ezOnEzApiReadyEventName,
                    EzLayoutHelper.#ezRegistrator);
            }
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond above section !!
    // NO CODE AFTER THIS SECTION
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
}
